import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import { AuthAction, AuthState } from "@/components/auth/types";
import { LoginCredentialsDto } from "@/services/apiService/api.types";
import apiService from "@/services/apiService/apiService";
import storageService from "@/services/storageService/storageService";
import { LocalStorageItems } from "@/helpers/constants";
import apiStorageInterface from "@/services/apiStorageInterface";
import store from "@/store";
import { Namespace } from "@/store/types";
import { AlertAction, AlertType } from "@/components/alert/types";

const logIn = async (
  context: ActionContext<AuthState, RootState>,
  logInCredentials: LoginCredentialsDto
): Promise<void> => {
  try {
    await apiService.logIn(logInCredentials).then((authData) => {
      storageService.setItem(LocalStorageItems.Token, authData.token, 0);
      storageService.setItem(LocalStorageItems.DeviceId, authData.deviceId, 0);
    });
    await apiStorageInterface.fetchSortedCategories();
  } catch (error) {
    switch (error.response.status) {
      case 422:
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: "Incorrect username or password",
          alertType: AlertType.Danger
        });
        break;
      case 500:
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: "Internal server error",
          alertType: AlertType.Danger
        });
        break;
    }
  }
};

export const actions: ActionTree<AuthState, RootState> &
  Record<AuthAction, Action<AuthState, RootState>> = {
  [AuthAction.logIn]: logIn
};
